import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["LoadingScreen"]),
    _createCommentVNode("    <AppDisclaimer v-if=\"disclaimerOpen\" @close=\"closeDisclaimer\"/>"),
    _createVNode($setup["AppHeader"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createVNode($setup["AppFooter"], { class: "footer" }),
    _createVNode($setup["CurrentBlockchain"]),
    _createVNode($setup["AppSidebar"]),
    _createCommentVNode("    <div class=\"ari10-widget-wrapper\" data-widget-id='41875703-9ee2-4729-9d51-e574c61467c3'></div>")
  ]))
}